import { createContext, useEffect, useState } from "react";
import { auth } from "../firebase";
import { fetchMembersData } from "../utils/fetchMembersData";

export const MemberContext = createContext();

export const MemberProvider = ({ children }) => {
  const [membersList, setMembersList] = useState([]);
  const [membersLoading, setMembersLoading] = useState(true);

  const [authInitialized, setAuthInitialized] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const [currentUserInfo, setCurrentUserInfo] = useState(null);

  // -------- Auth 状態（スマホ対策：一度だけ初期化） --------
  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      // ユーザーがログアウトされた場合、currentUserInfo をリセット
      if (!user) {
        setCurrentUserInfo(null);
      }
      setAuthInitialized(true);
    });
    return () => unsub();
  }, []);

  // -------- membersList 取得 --------
  useEffect(() => {
    if (!authInitialized || !currentUser) return;

    const unsub = fetchMembersData((membersData) => {
      setMembersList(membersData);
      setMembersLoading(false);
    });

    return () => unsub();
  }, [authInitialized, currentUser]);

  // -------- currentUserInfo の決定（最重要） --------
  useEffect(() => {
    if (!currentUser || membersList.length === 0) return;

    const matched = membersList.find((m) => m.author?.id === currentUser.uid);

    // 空オブジェクト防止
    if (matched && Object.keys(matched).length > 0) {
      setCurrentUserInfo(matched);
    } else {
      setCurrentUserInfo(null);
    }
  }, [currentUser, membersList]);

  return (
    <MemberContext.Provider
      value={{
        membersList,
        membersLoading,
        currentUser,
        currentUserInfo,
        setCurrentUserInfo,
      }}
    >
      {children}
    </MemberContext.Provider>
  );
};
